<!-- <img    #img [src]="message?.MediaUrl|src" (load)="autoResizeImage(230,0)" (click)="imgPreview(message)" /> -->
<img nz-image #img (click)="imgPreview(message)" (load)="autoResizeImage(230,0)" [nzSrc]="message?.MediaUrl|src" [nzDisablePreview]="true"
    [nzFallback]="fallback" />
<div *ngIf="message?.SendStatus==0" style="width: 230px;">
    <nz-progress [nzPercent]="message?.Progress" nzSize="small" nzStatus="active"></nz-progress>
</div>